export const MAX_LENGTH_FEET = 34;
export const MAX_WIDTH_FEET = 24;
export const MAX_LENGTH_METERS = 10.5;
export const MAX_WIDTH_METERS = 7.25;
